import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import App from './App.vue'
import router from './router/routes';

Vue.config.productionTip = false
const moment = require('moment')
Vue.use(require('vue-moment'), {
  moment
});
Vue.use(ToggleButton)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')


